<template>
  <div>
    <base-header class="pb-6  bg-gradient-info">
    <div style="min-height:30px;"></div>
    
    
      <div v-if="0" class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Default</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </div>
      </div>
      
      
      
    </base-header>

    <!--start container-->
    <div class="container-fluid mt--6">
      <div class="row">
      
      
       <div v-for="o in officers"  :key="o.id" class="col-xl-4">
          <card header-classes="bg-gradient-default">
            <div slot="header" class="row align-items-center">
              <div class="col text-center">
                <h3 class="h3 text-white">
                	<span v-if="o.pivot.position==1">Director</span>
                	<span v-if="o.pivot.position==2">Nominee Director</span>
                	<span v-if="o.pivot.position==3">Secretary</span>
                	<span v-if="o.pivot.position==4">Director & Secretary</span>
                
                </h3>
              </div>
            </div>

            <div>
                <span class="h6 surtitle">Name</span>
                <div class="h3 ">{{o.person.first_name}} {{o.person.last_name}}</div>
             </div>
             
             
              <div style="margin-top:30px;">
                <span class="h6 surtitle">Title</span>
                <div class="h3 ">
                	<span v-if="o.pivot.title"> {{o.pivot.title}}</span>
               		<span v-else> - </span>
                
                </div>
             </div>
             
              <div style="margin-top:30px;">
                <span class="h6 surtitle">Citizenship</span>
                <div class="h3 ">
                		<span v-if="o.person.citizenship==1">Singapore Citizen</span>
                		<span v-if="o.person.citizenship==2">Singapore PR</span>
                	    <span v-if="o.person.citizenship==3">Foreign Citizen</span>
                		<span v-if="!o.person.citizenship">-</span>
                </div>
             </div>
             
             
             
             
             <div style="margin-top:30px;">
                <span class="h6 surtitle">Email</span>
                <div class="h3 ">{{o.person.email}}</div>
             </div>
             
         
               <div style="margin-top:30px;">
                <span class="h6 surtitle">Contact Number</span>
                <div class="h3 ">
                	<span v-if="o.person.contact_num"> {{o.person.contact_num}}</span>
               		<span v-else> - </span>
                
                </div>
             </div>
              
              
             <div style="margin-top:30px;">
                <span class="h6 surtitle">Address</span>
                <div class="h3 ">
                	<span v-if="o.person.address_1"> {{o.person.address_1}}</span>
               		<span v-else> - </span>
                
                </div>
             </div>
             
        
          
          
          </card>
        </div>
       <!-- end column --> 
    

       
      </div>
      <!-- End row-->

      <!--start new row-->
     




    
    </div>  <!--End container-->
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>

  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';

  export default {
    components: {
  
    },
    data() {
      return {
     	 officers:[],
	
      };
    },
    methods: {
      initBigChart(index) {

      }
    },
    mounted() {
      	swal.showLoading();
        const client_info = JSON.parse(TokenService.getUserInfo());
      	let uri = this.$base_url+'/api/v1/c/get_e_officers/'+ client_info.entity_id;
         ApiService.get(uri).then(response => {
         	
      		 const vm = this;
      		 this.officers = response.data.officers;
      		 swal.close();
   
      	})
      	
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














